<template>
    <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item in levelListyi" :key="item.path" :to="{ path: item.path }">
            {{ item.name }}
        </el-breadcrumb-item>
        <el-breadcrumb-item v-for="item in levelList" :key="item.path" :to="{ path: item.path }">
            {{ item.meta.title }}
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script setup name="Breadcrumb">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()

const levelList = computed(() => route.matched.filter(item => item.meta && item.meta.breadcrumb))
const levelListyi = computed(() =>
    route.matched.filter(item => item.children && item.children.length > 0)
)
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 8px;

    .no-redirect {
        color: #97a8be;
        cursor: text;
    }
}
</style>
